import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";

import logo from "../../assets/icons/csrl-logo.png";

const navStyles = {
	display: "flex",
	justifyContent: "center",
};

const FormNavBar = () => {
	return (
		<Box sx={{ flexGrow: 1 }}>
			<AppBar position="fixed">
				<Toolbar sx={{ ...navStyles, backgroundColor: "#fff" }}>
					<div style={{ height: "3.5rem", width: "auto" }}>
						<img src={logo} alt="" height="100%" width="!00%" />
					</div>
				</Toolbar>
				<Toolbar sx={navStyles}>
					<Typography variant="h6" sx={{ textAlign: "center" }} component="div">
						KYC Update Form
					</Typography>
				</Toolbar>
			</AppBar>
		</Box>
	);
};

export default FormNavBar;
